const IMAGE_MAX_DIMENSION = 8000;

export const checkImageDimensions = (file: File): Promise<boolean> => {
  return new Promise((resolve) => {
    const img = new window.Image();
    img.onload = () => {
      if (img.width > IMAGE_MAX_DIMENSION || img.height > IMAGE_MAX_DIMENSION) {
        resolve(false);
      } else {
        resolve(true);
      }
    };
    img.onerror = () => resolve(false);
    img.src = URL.createObjectURL(file);
  });
};
